import { 
    BarChart3, 
    List, 
    Building, 
    Users, 
    MegaphoneIcon, 
    Sparkles, 
    UserPlus, 
    Mail, 
    Calendar, 
    TrendingUp 
} from "lucide-react"
import { Sidebar, SidebarSection } from "../../../components/Sidebar"

const sections: SidebarSection[] = [
    {
        header: "Admin Resources",
        visible: true,
        links: [
            {
                to: "/admin/dashboard",
                text: "Dashboard",
                iconComponent: <BarChart3 size={16} />,
                enabled: true,
                visible: true,
                end: false
            },
            {
                to: "/admin/projects",
                text: "Projects",
                iconComponent: <List size={16} />,
                enabled: true,
                visible: true,
                end: false
            },
            {
                to: "/admin/organizations",
                text: "Organizations",
                iconComponent: <Building size={16} />,
                enabled: true,
                visible: true,
                end: false
            },
            {
                to: "/admin/users",
                text: "Users",
                iconComponent: <Users size={16} />,
                enabled: true,
                visible: true,
                end: false
            },
            {
                to: "/admin/smartlead",
                text: "Campaigns",
                iconComponent: <MegaphoneIcon size={16} />,
                enabled: true,
                visible: true,
                end: false
            },
            {
                to: "/admin/brands",
                text: "Brands",
                iconComponent: <Sparkles size={16} />,
                enabled: true,
                visible: true,
                end: false
            },
            {
                to: "/admin/onboarding",
                text: "Onboarding",
                iconComponent: <UserPlus size={16} />,
                enabled: true,
                visible: true,
                end: false
            },
            {
                to: "/admin/messages",
                text: "Messages",
                iconComponent: <Mail size={16} />,
                enabled: true,
                visible: true,
                end: false
            },
            {
                to: "/admin/meetings",
                text: "Meetings",
                iconComponent: <Calendar size={16} />,
                enabled: true,
                visible: true,
                end: false
            },
            {
                to: "/admin/advisor-shares",
                text: "Advisor Shares",
                iconComponent: <TrendingUp size={16} />,
                enabled: true,
                visible: true,
                end: false
            }
        ]
    }
]

export const AdminSidebar = () => {
    return (
        <Sidebar sections={sections} className="admin" />
    )
}


    /*

              <NavLink to={`/admin/dashboard`}>
            <div className="sidebar-tab">
              <p><span className="sidebar-label">Dashboard</span></p>
            </div>
          </NavLink>
          <NavLink to={`/admin/projects`}>
            <div className="sidebar-tab">
              <p><span className="sidebar-label">Projects</span></p>
            </div>
          </NavLink>
          <NavLink to={`/admin/organizations`}>
            <div className="sidebar-tab">
              <p><span className="sidebar-label">Organizations</span></p>
            </div>
          </NavLink>
          <NavLink to={`/admin/users`}>
            <div className="sidebar-tab">
              <p><span className="sidebar-label">Users</span></p>
            </div>
          </NavLink>
          <NavLink to={`/admin/smartlead`}>
            <div className="sidebar-tab">
              <p><span className="sidebar-label">Campaigns</span></p>
            </div>
          </NavLink>
          <NavLink to={`/admin/brands`}>
            <div className="sidebar-tab">
              <p><span className="sidebar-label">Brands</span></p>
            </div>
          </NavLink>
          <NavLink to={`/admin/onboarding`}>
            <div className="sidebar-tab">
              <p><span className="sidebar-label">Onboarding</span></p>
            </div>
          </NavLink>
          <NavLink to={`/admin/messages`}>
            <div className="sidebar-tab">
              <p><span className="sidebar-label">Messages</span></p>
            </div>
          </NavLink>
          <NavLink to={`/admin/meetings`}>
            <div className="sidebar-tab">
              <p><span className="sidebar-label">Meetings</span></p>
            </div>
          </NavLink>
          <NavLink to={`/admin/advisor-shares`}>
            <div className="sidebar-tab">
              <p><span className="sidebar-label">Advisor Shares</span></p>
            </div>
          </NavLink>

          */